import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { TimeOffTypesQueryParams } from '../types';

/** Owner/Admin only. Ordered by `order` then `name` by the backend. */
export function useTimeOffTypes(params?: TimeOffTypesQueryParams) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.types(orgId, params),
    queryFn: ({ signal }) => timeOffService.getTypes(params, signal),
    staleTime: 300_000,
    enabled: !!orgId,
  });
}
